import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import apiService from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const CreateAgencyPage: React.FC = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();
const { switchAgency } = useAuth();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) { showError('Agency name is required'); return; }
    setLoading(true);
    try {
      const response = await apiService.post('/agencies/create', { name });
      const newAgencyId = response.data.agency.agency_id;
      showSuccess('Agency created successfully');
      await switchAgency(newAgencyId);
      navigate('/dashboard');
    } catch (err: any) {
      showError(err.message || 'Failed to create agency');
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '32px', maxWidth: '480px', fontFamily: 'var(--font-sans)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <div style={{
          width: '40px', height: '40px', borderRadius: 'var(--radius-md)',
          backgroundColor: 'var(--v2-primary-light)', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <Building2 size={22} strokeWidth={1.5} color="var(--v2-primary)" />
        </div>
        <div>
          <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--v2-text)', margin: 0 }}>
            Create New Agency
          </h1>
          <p style={{ fontSize: '0.875rem', color: 'var(--v2-text-tertiary)', margin: 0 }}>
            Set up a new agency account
          </p>
        </div>
      </div>

      <div style={{
        backgroundColor: 'var(--v2-surface)', borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--v2-border)', padding: '24px',
      }}>
        <label style={{
          display: 'block', fontSize: '0.6875rem', fontWeight: 600,
          color: 'var(--v2-text-muted)', textTransform: 'uppercase',
          letterSpacing: '0.05em', marginBottom: '6px',
        }}>
          Agency Name
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
          placeholder="Acme Corporation"
          autoFocus
          style={{
            width: '100%', padding: '10px 12px',
            border: '1px solid var(--v2-border)', borderRadius: 'var(--radius-sm)',
            fontSize: '0.875rem', color: 'var(--v2-text)',
            backgroundColor: 'var(--v2-surface)', outline: 'none',
            boxSizing: 'border-box', marginBottom: '20px',
          }}
        />

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: '10px 20px', backgroundColor: 'var(--v2-surface)',
              border: '1px solid var(--v2-border)', borderRadius: 'var(--radius-md)',
              fontSize: '0.875rem', cursor: 'pointer', color: 'var(--v2-text)',
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !name.trim()}
            style={{
              padding: '10px 20px',
              backgroundColor: (loading || !name.trim()) ? 'var(--v2-border)' : 'var(--v2-primary)',
              color: (loading || !name.trim()) ? 'var(--v2-text-muted)' : '#fff',
              border: 'none', borderRadius: 'var(--radius-md)',
              fontSize: '0.875rem', fontWeight: 500,
              cursor: (loading || !name.trim()) ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Creating...' : 'Create Agency'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateAgencyPage;
